import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { TextInputWrapper } from 'shared/components/fields/text/index';
import { useBooleanState } from 'shared/hooks/state/boolean';
export function PasswordInput(props) {
    const [shown, noShown, setShown] = useBooleanState(false);
    return (_jsx(TextInputWrapper, { ...props, type: shown ? 'text' : 'password', endAdornment: _jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { edge: "end", title: shown ? 'скрыть пароль' : 'показать пароль', onClick: shown ? noShown : setShown, size: "large", children: shown ? _jsx(Visibility, {}) : _jsx(VisibilityOff, {}) }) }) }));
}
